import React from "react";
import { MainMenu } from "./Header/mainMenu";

export function MainPageContent(): JSX.Element {
  return (
    <div>
      <MainMenu />
    </div>
  );
}
